export function buildStandardTrainingRequest({
  questionCount,
  selectedTopics
}) {
  const params = {
    mode: 'TRAINING_MODE',
    limit: questionCount,
    excludeAnswered: 'true'
  }

  const topicsToSend = Array.isArray(selectedTopics)
    ? selectedTopics.filter(topic => topic && topic !== 'ALL_TOPICS')
    : []

  if (topicsToSend.length > 0) {
    params.topics = topicsToSend.join(';;;')
  }

  return params
}
